/* istanbul ignore file */
export const assertNever = (x) => x;
